import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Slide,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { initializeGTM } from "../../utils/gtm";
import { useStyles } from "./CookiesPopup.styles";

const CookiesPopup: React.FC = () => {
  const classes = useStyles();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [open, setOpen] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);

  // Initial load
  useEffect(() => {
    const hasCookies = localStorage.getItem("bhss-open-cookies");

    if (hasCookies !== "true") {
      setOpen(true);
    } else {
      // Only initialize GTM if analytics was accepted before
      const analyticsAccepted = localStorage.getItem("bhss-cookies") === "true";

      if (analyticsAccepted) {
        initializeGTM();
      }
    }
  }, []);

  const confirmOnlySelected = useCallback(() => {
    // Popup should never open again
    localStorage.setItem("bhss-open-cookies", "true");

    // Enable analytics only if selected
    if (analyticsEnabled) {
      localStorage.setItem("bhss-cookies", "true");
      initializeGTM();
      // Reload to ensure GTM loads properly
      window.location.reload();
    }

    setOpen(false);
  }, [analyticsEnabled]);

  const acceptAll = useCallback(() => {
    localStorage.setItem("bhss-open-cookies", "true");
    localStorage.setItem("bhss-cookies", "true");

    initializeGTM();
    // Reload to ensure GTM loads properly
    window.location.reload();

    setOpen(false);
  }, []);

  return (
    <Slide in={open} direction="up">
      <Box className={classes.popup}>
        <Container>
          <Box className={classes.holder}>
            {/* LEFT TEXT BLOCK */}
            <Box className={classes.holderInfo}>
              <Typography className={classes.textBlock}>
                {t("dialog.cookies_choose")}
              </Typography>

              <a
                href={`${process.env.REACT_APP_BALTHAUS_URL}/${language}/apsauga/`}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.moreLink}
              >
                {t("dialog.privacy_link")}
              </a>
            </Box>

            {/* RIGHT COOKIES + ACTIONS */}
            <Box className={classes.holderCookies}>
              {/* CHECKBOX ROW */}
              <Box className={classes.cookiesRow}>
                {/* NECESSARY */}
                <Box className={classes.cookiesBlock}>
                  <FormControlLabel
                    control={<Checkbox checked color="primary" />}
                    label={
                      <Typography className={classes.checkboxTitle}>
                        {t("dialog.necessary")}
                      </Typography>
                    }
                  />
                  <Typography className={classes.cookiesDescription}>
                    {t("dialog.necessary_description")}
                  </Typography>
                </Box>

                {/* ANALYTICS */}
                <Box className={classes.cookiesBlock}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={analyticsEnabled}
                        onChange={e => setAnalyticsEnabled(e.target.checked)}
                        color="primary"
                      />
                    }
                    label={
                      <Typography className={classes.checkboxTitle}>
                        {t("dialog.analytical")}
                      </Typography>
                    }
                  />
                  <Typography className={classes.cookiesDescription}>
                    {t("dialog.analytical_description")}
                  </Typography>
                </Box>
              </Box>

              {/* BUTTONS */}
              <Box className={classes.btnHolder}>
                <Button
                  className={classes.linkBtn}
                  onClick={confirmOnlySelected}
                >
                  {t("dialog.confirm_only_selected")}
                </Button>

                <Button className={classes.linkBtn} onClick={acceptAll}>
                  {t("dialog.accept_all")}
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </Slide>
  );
};

export default CookiesPopup;
